<template>
  <qx-card title="保养记录" class="detail">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='vehicleServiceBO.ajax?cmd=getVehicleMaintenanceRecordList'
          :params="fullSearchData"
          bizName="车辆保养记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <!-- <section slot-scope="scope"></section> -->
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import ExportBtn from 'components/exportBtn';
import tableMixin from '@qx/mixin/table';
import {getVehicleMaintenanceRecordList} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      searchBoxData: {
        vehicleCode: this.$route.query.id,

      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'maintenanceDate',
            label: '保养日期',
          },
          {
            prop: 'drivingDistanceDouble',
            label: '行驶里程（km）',
          },
          {
            prop: 'maintenanceProject',
            label: '保养项目',
          },
          {
            prop: 'amountDouble',
            label: '金额',
          },
          {
            prop: 'serviceSite',
            label: '服务站点',
          },
          {
            prop: 'serviceName',
            label: '服务商',
          },
          {
            prop: 'remark',
            label: '备注',
          },
          {
            prop: 'mileageForNextMaintenanceDouble',
            label: '下次保养里程数（km）',
          },
          {
            prop: 'nextMaintenanceDate',
            label: '下次保养日期',
          },
          {
            prop: 'maintenancePersonnel',
            label: '保养人员',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getVehicleMaintenanceRecordList,
  },
};
</script>

<style>
</style>
